import { REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = {
  isOnboarded: {
    'End Rhyme': false,
    'Internal Rhyme': false,
    Alliteration: false,
    Onomatopoeia: false,
    Repetition: false,
  },
};

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.COMPLETE_ONBOARDING: {
      const onboarding = state.isOnboarded;
      onboarding[payload] = true;
      return {
        ...state,
        isOnboarded: onboarding,
      };
    }
    default:
      return state;
  }
};

export default screenReducer;
